import React from "react";
import { useLocation } from "react-router-dom";


export const useQueryParms = ()=>{
    const { search, pathname } = useLocation();
    const queryParams = new URLSearchParams(search)

    return {queryParams, pathname}
}